import React, { useState } from 'react';
import { Modal, Button, TextField, Alert } from '@dopomogai/ui';

export interface CreateSecretModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (name: string, plaintextValue: string) => Promise<void>;
}

export const CreateSecretModal: React.FC<CreateSecretModalProps> = ({ isOpen, onClose, onCreate }) => {
  const [name, setName] = useState('');
  const [value, setValue] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const handleSubmit = async () => {
    setErr(null);
    if (!name.trim() || !value.trim()) {
      setErr('Name and value are required.');
      return;
    }
    setSubmitting(true);
    try {
      await onCreate(name.trim(), value);
      setName('');
      setValue('');
      onClose();
    } catch (e: any) {
      setErr(e?.message || 'Failed to create secret.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => !submitting && onClose()}
      title="Create secret"
      size="md"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={submitting}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Creating…' : 'Create'}
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-slate-600">
          Enter a name and value. You won’t see this value again after creation.
        </p>
        {err && <Alert type="error" message={err} />}
        <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} placeholder="STRIPE_API_KEY" />
        <TextField label="Value" value={value} onChange={(e) => setValue(e.target.value)} placeholder="••••••••" type="password" />
      </div>
    </Modal>
  );
};